import React from 'react';
import { CalendarRangeIcon, CompassIcon, ClipboardListIcon, GiftIcon, ShieldCheckIcon, MoonStarIcon } from 'lucide-react';
import { CtaBlock, CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { InsidePages } from '../components/InsidePages';
import { StickyCta } from '../components/StickyCta';
import { GUARANTEE_TEXT, GUARANTEE_TITLE, bonuses, faqs, guides, heroBenefits, offerIncludes, painPoints, testimonials } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/3mwrhkUoCDtynSAjfGyryU/mockup2.png';
const LIFESTYLE_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/e6a6c5cf-96a0-4b94-b2be-7cd50b5302df.jpg';
const benefitIcons = [CompassIcon, ClipboardListIcon, CalendarRangeIcon];
const HERO_META = '6 Digital Guides + 5 Free Bonuses • Instant Digital Access • One-Time Payment';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-37" data-mp="3vnjowda08ihr">
      {/* Header */}
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-38" data-mp="35t04hfonw4cn">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-2.5 lg:px-8" data-id="element-39" data-mp="35qx5451mcyv9">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-40" data-mp="30rua7dfcs910">
            Prof.Kyra
          </p>
          <div className="flex items-center gap-4" data-id="element-41" data-mp="3tiue7odopcso">
            <CtaButton label="Get Access" action="offer" size="md" className="hidden px-4 py-2 text-[11px] md:inline-flex" data-id="element-42" data-mp="3tghxfejnx8h7" />
          </div>
        </div>
      </header>

      <main data-id="element-43" data-mp="3fjckqvpg1bcz">
        {/* 01 — HERO */}
        <section className="bg-brand-ivory px-5 pb-16 pt-12 lg:px-8 lg:pb-24 lg:pt-16" data-id="element-44" data-mp="3fi9tuns4f8x2">
          <div className="mx-auto max-w-3xl text-center" data-id="element-45" data-mp="286116m3gry5s">
            <p className="flex items-center justify-center gap-2 font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-46" data-mp="243w9vu0hndmb">
              <MoonStarIcon className="h-3.5 w-3.5 text-brand-charcoal/40" strokeWidth={1.25} aria-hidden="true" data-id="element-47" data-mp="25lctyxtrst7t" />
              Real Solutions for Tired Parents
            </p>
            <h1 className="mt-6 font-display text-[2.5rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.25rem] lg:text-[4rem]" data-id="element-48" data-mp="20lqfym64b8xy">
              Get Your Baby Sleeping Better—and Your Nights Back
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-[16px] leading-relaxed text-brand-charcoal/70 sm:text-[17px]" data-id="element-49" data-mp="1rm3n4orgfbgi">
              Follow a clear, age-by-age sleep system with ready-to-use schedules and gentle
              routines—so you can stop guessing and start sleeping better.
            </p>
          </div>

          {/* Product — warm halo so the mockup sits in the page, not on top of it */}
          <div className="relative mx-auto mt-12 w-full max-w-[720px]" data-id="element-50" data-mp="17vrokk4gazq4">
            <div aria-hidden="true" className="absolute left-1/2 top-[54%] h-[66%] w-[88%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-brand-oatmeal opacity-75 blur-2xl" data-id="element-51" data-mp="p894nyvytpvl" />
            <img src={MOCKUP_URL} alt="The Baby Sleep Bible by Prof. Kyra — the complete set of six digital sleep guides" width={912} height={759} className="relative mx-auto block w-full max-w-[380px] object-contain lg:max-w-[660px]" style={{
            filter: 'drop-shadow(0 28px 34px rgba(120, 84, 64, 0.18))'
          }} data-id="element-52" data-mp="yaieemjetf7x" />
          </div>

          <div className="mx-auto mt-12 max-w-4xl" data-id="element-53" data-mp="1gzf2u9s4ldi8">
            <ul className="grid gap-7 border-y border-brand-charcoal/12 py-8 sm:grid-cols-3" role="list" data-id="element-54" data-mp="1cxtmufkaoj3t">
              {heroBenefits.map((benefit, index) => {
              const Icon = benefitIcons[index];
              return <li key={benefit.label} className="text-center" data-id="element-55" data-mp="2614ec91xykjk" data-mpi={index}>
                    <Icon className="mx-auto h-5 w-5 text-brand-charcoal/70" strokeWidth={1.25} aria-hidden="true" data-id="element-56" data-mp="260w2mkhk1l9y" />
                    <p className="mt-3 font-body text-[14px] font-semibold text-brand-charcoal" data-id="element-57" data-mp="2eu7z72ex1zo8">
                      {benefit.label}
                    </p>
                    <p className="mx-auto mt-1 max-w-[16rem] text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-58" data-mp="1n31z2lz741yy">
                      {benefit.description}
                    </p>
                  </li>;
            })}
            </ul>

            <div id="hero-cta" data-id="element-59" data-mp="1w5b6h2z63f84">
              <CtaBlock label="Get the Baby Sleep Bible" meta={HERO_META} className="mt-10" data-id="element-60" data-mp="212ktkbz33ess" />
            </div>
          </div>
        </section>

        {/* 02 — IS THIS FOR YOU */}
        <section aria-labelledby="for-you-heading" className="bg-brand-blush px-5 py-16 lg:px-8 lg:py-20" data-id="element-61" data-mp="3ch82qr3xtd86">
          <div className="mx-auto max-w-2xl text-center" data-id="element-62" data-mp="10stj1n9ezosy">
            <h2 id="for-you-heading" className="font-display text-[2.1rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.6rem]" data-id="element-63" data-mp="vuryexwcbhfd">
              This Product Is for You If:
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-64" data-mp="m3xe3z2nmrwk">
              Any of this sounds like your day — or your 3 a.m.
            </p>
          </div>

          <div className="mx-auto mt-12 grid max-w-5xl items-start gap-10 lg:grid-cols-[0.78fr_1.22fr] lg:gap-14" data-id="element-65" data-mp="d3r1sgiozxyz">
            <img src={LIFESTYLE_URL} alt="A baby sleeping calmly in a quiet, neutral nursery" width={936} height={1170} loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-[16px] object-cover" data-id="element-66" data-mp="868s2nwupepx" />
            <ul className="border-t border-brand-charcoal/15" role="list" data-id="element-67" data-mp="1xknbcsp3o9e1">
              {painPoints.map(pain => <li key={pain.text} className="flex items-center gap-4 border-b border-brand-charcoal/15 py-3.5" data-id="element-68" data-mp="3ry9b795kdgq4">
                  <span aria-hidden="true" className="text-[18px] leading-none" data-id="element-69" data-mp="3i3hb9yoiehs6">
                    {pain.emoji}
                  </span>
                  <span className="text-[15px] leading-snug text-brand-charcoal" data-id="element-70" data-mp="3mywnkm6vc5mh">{pain.text}</span>
                </li>)}
            </ul>
          </div>

          <CtaBlock label="Get Instant Access" className="mx-auto mt-12 max-w-md" data-id="element-71" data-mp="jk0ouitmxm6e" />
        </section>

        {/* 03 — THE SYSTEM */}
        <section aria-labelledby="system-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-72" data-mp="5n432vsdiuwd">
          <div className="mx-auto max-w-6xl" data-id="element-73" data-mp="2qaqo0dot03f2">
            <div className="mx-auto max-w-2xl text-center" data-id="element-74" data-mp="2qd34snits7qj">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-75" data-mp="2udmzlkfxez9i">
                The System
              </p>
              <h2 id="system-heading" className="mt-4 font-display text-[2.1rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.6rem]" data-id="element-76" data-mp="2htzt347cxb17">
                One Sleep System. Six Essential Guides.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-77" data-mp="2rsxehy9hkofz">
                Each guide covers a different challenge and stage, so the system stays with you as
                your baby grows and sleep keeps shifting.
              </p>
            </div>

            <ol className="mt-12 grid gap-x-14 border-t border-brand-charcoal/12 sm:grid-cols-2" data-id="element-78" data-mp="2dt674gdh66ay">
              {guides.map(guide => <li key={guide.number} className="flex items-start gap-4 border-b border-brand-charcoal/12 py-6" data-id="element-79" data-mp="28zti454vvxho">
                  <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full font-body text-[12px] font-semibold text-brand-charcoal" style={{
                backgroundColor: guide.accent
              }} aria-hidden="true" data-id="element-80" data-mp="1gch7mtbzzg4q">
                    {guide.number}
                  </span>
                  <span data-id="element-81" data-mp="18tykfcvzrlfw">
                    <span className="block font-display text-[1.4rem] font-bold leading-snug text-brand-charcoal" data-id="element-82" data-mp="18u8bl3srvyn6">
                      {guide.title}
                    </span>
                    <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-83" data-mp="1iquuvo5gahn3">
                      {guide.description}
                    </span>
                  </span>
                </li>)}
            </ol>
          </div>
        </section>

        {/* 04 — A LOOK INSIDE */}
        <section aria-labelledby="inside-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-20" data-id="element-84" data-mp="1wk2plootvt90">
          <div className="mx-auto max-w-6xl" data-id="element-85" data-mp="21g1i9oh6vxf8">
            <div className="mx-auto max-w-2xl text-center" data-id="element-86" data-mp="3m0ez8na2wkw7">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-87" data-mp="3lxsibx1ast1b">
                A Look Inside
              </p>
              <h2 id="inside-heading" className="mt-4 font-display text-[2.1rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.6rem]" data-id="element-88" data-mp="3d09ukkw9s0lq">
                Practical Guidance for Real Life.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-89" data-mp="4jx0f1jbmmwg">
                Clear schedules, practical guidance and easy-reference tools designed for tired
                parents.
              </p>
            </div>

            <div className="mt-10" data-id="element-90" data-mp="3qyq92y0divef">
              <InsidePages data-id="element-91" data-mp="s99a02ik8wza" />
            </div>

            <CtaBlock label="Get All 6 Guides" meta="6 Digital Guides • Instant Access • One-Time Payment" className="mx-auto mt-12 max-w-md border-t border-brand-charcoal/12 pt-10" data-id="element-92" data-mp="saav6ztaizuq" />
          </div>
        </section>

        {/* 05 — TESTIMONIALS */}
        <section aria-labelledby="testimonials-heading" className="bg-brand-blush px-5 py-16 lg:px-8 lg:py-20" data-id="element-93" data-mp="2wggiafmvq0dq">
          <div className="mx-auto max-w-6xl" data-id="element-94" data-mp="3aclf3ap1ts6g">
            <h2 id="testimonials-heading" className="text-center font-display text-[2.1rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.6rem]" data-id="element-95" data-mp="36c9qxnxh99q8">
              What Parents Say.
            </h2>
            <div className="mt-12 grid gap-10 sm:grid-cols-3 sm:gap-8" data-id="element-96" data-mp="3fc6n0am75avb">
              {testimonials.map(testimonial => <blockquote key={testimonial.name} className="border-t border-brand-charcoal/20 pt-6" data-id="element-97" data-mp="3p42olvnhrj4a">
                  <p className="font-display text-[1.35rem] font-normal italic leading-[1.45] text-brand-charcoal" data-id="element-98" data-mp="6xo9htdhl34b">
                    “{testimonial.quote}”
                  </p>
                  <footer className="mt-5" data-id="element-99" data-mp="lkwqjath82o7">
                    <p className="font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-100" data-mp="lly01auugh3t">
                      {testimonial.name}
                    </p>
                    <p className="mt-0.5 font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-101" data-mp="ck8bqdw9dya9">
                      {testimonial.country}
                    </p>
                  </footer>
                </blockquote>)}
            </div>
          </div>
        </section>

        {/* 06 — FINAL OFFER */}
        <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-20" data-id="element-102" data-mp="7m6rvqr0duxq">
          <div className="mx-auto max-w-3xl text-center" data-id="element-103" data-mp="3u0gdxt7guqvc">
            <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-104" data-mp="3u0zm4i7be0w6">
              The Complete Bundle
            </p>
            <h2 id="offer-heading" className="mt-4 font-display text-[2.4rem] font-bold leading-[1.04] text-brand-charcoal sm:text-[2.9rem]" data-id="element-105" data-mp="3l0bblxh4qio1">
              The Baby Sleep Bible
            </h2>

            <div className="relative mx-auto mt-8 w-full max-w-[520px]" data-id="element-106" data-mp="1lrs3wdf4h80n">
              <div aria-hidden="true" className="absolute left-1/2 top-[56%] h-[62%] w-[86%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-[#E3D3BF] opacity-75 blur-2xl" data-id="element-107" data-mp="1gutaxy773741" />
              <img src={MOCKUP_URL} alt="The Baby Sleep Bible — six digital guides included in the bundle" width={912} height={759} loading="lazy" decoding="async" className="relative mx-auto block w-full max-w-[340px] object-contain lg:max-w-[470px]" style={{
              filter: 'drop-shadow(0 24px 28px rgba(120, 84, 64, 0.2))'
            }} data-id="element-108" data-mp="29hw56e4u8voh" />
            </div>

            <ul className="mx-auto mt-10 inline-flex flex-col gap-2.5 text-left" role="list" data-id="element-109" data-mp="k2661b5vd2sw">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/80" data-id="element-110" data-mp="30q74wtzs6hjk">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 flex-none rounded-full bg-brand-charcoal/40" data-id="element-111" data-mp="34qhm72t0wudq" />
                  {item}
                </li>)}
            </ul>

            {/* 5 free bonuses */}
            <div className="mx-auto mt-10 max-w-xl rounded-[16px] border border-brand-charcoal/12 bg-brand-ivory px-6 py-7 text-left sm:px-8" data-id="element-112" data-mp="3jfdpyno1rl8j">
              <p className="flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/60" data-id="element-113" data-mp="3shd9bmmjb1en">
                <GiftIcon className="h-4 w-4" strokeWidth={1.25} aria-hidden="true" data-id="element-114" data-mp="1u2sew2m27iuj" />
                Plus 5 Free Bonuses
              </p>
              <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" role="list" data-id="element-115" data-mp="1y5f19nzyobkc">
                {bonuses.map((bonus, index) => <li key={bonus} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal" data-id="element-116" data-mp="yru9da0wcvcx" data-mpi={index}>
                    <span aria-hidden="true" className="mt-1.5 h-2 w-2 flex-none rounded-full" style={{
                  backgroundColor: ['#DFC0BC', '#CCD5C2', '#D9D3E3', '#CEDFEB', '#EEE4D6'][index]
                }} data-id="element-117" data-mp="1cozd33d51i50" />
                    {bonus}
                  </li>)}
              </ul>
            </div>

            <CtaBlock label="Get the Baby Sleep Bible" action="checkout" meta="6 Digital Guides + 5 Free Bonuses • One-Time Payment" className="mx-auto mt-10 max-w-md border-t border-brand-charcoal/15 pt-9" data-id="element-118" data-mp="p06aio20gc1f" />
          </div>
        </section>

        {/* 07 — FAQ */}
        <section aria-labelledby="faq-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-119" data-mp="2cr5jivoup2hu">
          <div className="mx-auto max-w-3xl" data-id="element-120" data-mp="1z0jzv4rkooiw">
            <h2 id="faq-heading" className="text-center font-display text-[2.1rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.6rem]" data-id="element-121" data-mp="1yxo1jfbtbxtx">
              Questions, Answered.
            </h2>
            <div className="mt-10 border-t border-brand-charcoal/12" data-id="element-122" data-mp="2vqjftka1ypbi">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-123" data-mp="2hr1lkpdzmjur" />)}
            </div>
          </div>
        </section>

        {/* Guarantee */}
        <section aria-labelledby="guarantee-heading" className="border-y border-brand-charcoal/10 bg-brand-paper px-5 py-12 lg:px-8" data-id="element-124" data-mp="2mrfxwjmmgfyl">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-125" data-mp="1bb7nxx4v22cw">
            <ShieldCheckIcon className="h-6 w-6 text-brand-charcoal/60" strokeWidth={1.25} aria-hidden="true" data-id="element-126" data-mp="3czlr1mswform" />
            <h2 id="guarantee-heading" className="mt-4 font-display text-[1.7rem] font-bold leading-snug text-brand-charcoal sm:text-[2rem]" data-id="element-127" data-mp="339iytotlqeuc">
              {GUARANTEE_TITLE}
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-128" data-mp="2u94aeglccjmm">
              {GUARANTEE_TEXT}
            </p>
          </div>
        </section>
      </main>

      {/* 08 — FOOTER */}
      <footer className="bg-brand-charcoal px-5 pb-32 pt-12 text-brand-ivory/70 md:pb-12 lg:px-8" data-id="element-129" data-mp="2k9wpn8ca1mph">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-130" data-mp="2g9usnchhlhgj">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-131" data-mp="ii0dbwiac8tn">
            Prof.Kyra
          </p>
          <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-132" data-mp="efvmt6n4vsb8">
            <a href="#terms" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-133" data-mp="1wdif395u2c91">
              Terms
            </a>
            <a href="#privacy" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-134" data-mp="2a8kk7u2uvxks">
              Privacy Policy
            </a>
            <a href="#refund" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-135" data-mp="1mji5ov3iqkui">
              Refund Policy
            </a>
            <a href="mailto:profkyra@gmail.com" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-136" data-mp="32x8ci9m0vn7u">
              Contact
            </a>
          </nav>
        </div>
        <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-137" data-mp="2ik6p7xmjaoxy">
          © 2026 Prof.Kyra. The Baby Sleep Bible is an educational resource and does not constitute
          medical advice. 7-day money-back guarantee. Payments are processed in your local currency.
        </p>
      </footer>

      <StickyCta data-id="element-138" data-mp="369hmh54oe17c" />
    </div>;
}